/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { CashBoxAuditHistoryDto } from '../../../api/cashBoxes/cashBoxesClient.typings';
import {
    CashBoxAuditTabAction,
    CashBoxAuditTabActionType,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxAuditTabActions';

export interface CashBoxAuditTabState {
    cashBoxAuditHistory: CashBoxAuditHistoryDto;
    isLoadingAuditHistory: boolean;
    isDownloadingAuditHistory: boolean;
}
const initialState: CashBoxAuditTabState = {
    cashBoxAuditHistory: null,
    isLoadingAuditHistory: false,
    isDownloadingAuditHistory: false,
};

export function cashBoxAuditTabReducer(
    state: CashBoxAuditTabState = initialState,
    action: CashBoxAuditTabAction,
): CashBoxAuditTabState {
    switch (action.type) {
        case CashBoxAuditTabActionType.FETCH_CASHBOX_AUDIT_HISTORY:
            return {
                ...state,
                isLoadingAuditHistory: true,
            };

        case CashBoxAuditTabActionType.FETCH_CASHBOX_AUDIT_HISTORY_SUCCESS:
            return {
                ...state,
                cashBoxAuditHistory: action.payload,
                isLoadingAuditHistory: false,
            };

        case CashBoxAuditTabActionType.FETCH_CASHBOX_AUDIT_HISTORY_ERROR:
            return {
                ...state,
                isLoadingAuditHistory: false,
                cashBoxAuditHistory: {
                    count: 0,
                    audits: [],
                },
            };

        case CashBoxAuditTabActionType.DOWNLOAD_AUDIT_HISTORY:
            return {
                ...state,
                isDownloadingAuditHistory: true,
            };

        case CashBoxAuditTabActionType.DOWNLOAD_AUDIT_HISTORY_SUCCESS:
        case CashBoxAuditTabActionType.DOWNLOAD_AUDIT_HISTORY_ERROR:
            return {
                ...state,
                isDownloadingAuditHistory: false,
            };

        case CashBoxAuditTabActionType.EXIT_CASHBOX_AUDIT_TAB:
            return {
                ...state,
                cashBoxAuditHistory: null,
            };

        default:
            break;
    }
    return state;
}
